module.exports = __webpack_public_path__ + "static/img/viral_09.61fcc7de.jpg";